module.exports = __webpack_public_path__ + "a8d62963607ac75633be758e98beeabc.jpg";